/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

// Not strictly a polyfill as it is an implementation of abandoned ecmascript spec for annotated metadata.
// So no browser actually implements it.  Mobx depends on it.
import "reflect-metadata";
import jQuery from "jquery";

// set window.$ and window.jQuery globally, so scripts can access it.
// jQuery doesn't set these globals in a common js environment, like webpack's environment
const settableWindow = window;
settableWindow.$ = settableWindow.jQuery = jQuery;
console.log("All polyfills loaded");
//# sourceMappingURL=Polyfills.js.map
